import CollectionPreview from "./CollectionPreview"

export default CollectionPreview